module.exports = __webpack_public_path__ + "static/media/mob_alert_partner_platinum_x1.81b36a4b.png";